import styled from 'styled-components';

export default styled.p`
  padding: 0 25px;
  margin: 10px 0 0;
  font-size: 13px;
  font-weight: 500;
`;
